export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Contact Us',
      description: 'Reach out by phone, email, or through our website. Tell us about your property and situation. We listen without judgment and answer all your questions.',
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: 'Property Assessment',
      description: 'We schedule a convenient time to view the property. This can be a quick walkthrough - we don\'t need access to every room or area. We assess the property\'s value and cleanup requirements.',
      icon: 'ri-home-line'
    },
    {
      number: '03',
      title: 'Receive Cash Offer',
      description: 'Within 24-48 hours, we present you with a fair, no-obligation cash offer. We explain how we arrived at the price and answer any questions you have.',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      number: '04',
      title: 'Accept & Schedule',
      description: 'If you accept our offer, we work with you to schedule a closing date that fits your timeline. We can close in as little as 7 days or wait longer if you need more time.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '05',
      title: 'Close the Sale',
      description: 'We handle all the paperwork and closing details. You sign the documents, receive your cash payment, and hand over the keys. That\'s it - you\'re done!',
      icon: 'ri-file-text-line'
    },
    {
      number: '06',
      title: 'We Handle Cleanup',
      description: 'After closing, our team begins the cleanup process. You don\'t have to be present or involved in any way. We take care of everything from removal to final cleaning.',
      icon: 'ri-checkbox-circle-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Simple <span className="text-teal-600">6-Step Process</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From first contact to final cleanup, we make selling your hoarder house as easy and stress-free as possible.
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-1 bg-teal-200 hidden md:block"></div>
          
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg relative z-10">
                      {step.number}
                    </div>
                  </div>
                  
                  <div className="flex-grow bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${step.icon} text-2xl text-teal-600`}></i>
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-3">{step.title}</h3>
                        <p className="text-gray-700 leading-relaxed">{step.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl p-10 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Ready to Get Started?</h3>
          <p className="text-xl mb-8 text-teal-50">
            The hardest part is making the first call. After that, we handle everything.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:+1234567890"
              className="px-8 py-4 bg-white text-teal-600 text-lg font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Now
            </a>
            <button 
              onClick={() => {
                const form = document.getElementById('contact-form');
                if (form) form.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-gray-900 text-white text-lg font-semibold rounded-lg hover:bg-gray-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Get Your Offer
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
